// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrapper":"Contract_buttonsWrapper__3LYQX"};